<template>
  <div class="w-full h-full p-4 box-border flex flex-col overflow-hidden" v-loading="tabLoading">
    <ul class="flex flex-wrap items-center pb-1">
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-select v-model="condition.settleObjType" size="small" class="w-full-imp" placeholder="结算对象" clearable>
          <el-option v-for="(st, key) in soTypeMapOption" :key="key" :label="st" :value="key" />
        </el-select>
      </li>
      <li class="w-52 mr-3 mb-3">
        <subjection-date-type ref="subDate" v-model="condition.settleMonth" :date-type.sync="settleTimeType" />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-input v-model="condition.settleName" size="small" class="w-full-imp" placeholder="结算名称" clearable />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-input v-model="condition.settleDept" size="small" class="w-full-imp" placeholder="部门" clearable />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-input v-model="condition.settleCode" :maxlength="50" size="small" class="w-full-imp" placeholder="结算代码" clearable />
      </li>
      <li class="w-64 mr-3 mb-3">
        <el-date-picker
          v-model="condition.dateRange"
          type="daterange"
          size="small"
          class="w-full-imp"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          clearable
        />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-input v-model="condition.creatorName" size="small" class="w-full-imp" placeholder="发起人" clearable />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-input v-model="condition.investigatorName" size="small" class="w-full-imp" placeholder="调查员姓名/代理" clearable />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-input v-model="condition.investigatorPhone" size="small" class="w-full-imp" placeholder="调查员手机号" clearable />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-select v-model="condition.projectCategory" size="small" class="w-full-imp" placeholder="项目类型" clearable>
          <el-option v-for="(pm, key) in projectCategoryMap" :key="key" :label="pm" :value="key" />
        </el-select>
      </li>
      <li style="width: 300px;" class="mr-3 mb-3">
        <input-field-range
          :placeholders="['结算总金额下限', '结算总金额上限']"
          v-model="condition.totalAmountRange"
          @startBlur="blurAmountHandle"
          @endBlur="blurAmountHandle"
        />
      </li>
      <li style="width: 208px;" class="mb-3">
        <el-button type="primary" size="small" class="ml-0-imp mr-3" @click="queryList">查询</el-button>
        <el-button type="primary" size="small" plain class="ml-0-imp no-plainbtn-theme" @click="resetList">重置</el-button>
        <el-button class="ml-3" type="text" size="small" :loading="exportLoading" v-if="exportLoading"> 导出 </el-button>
        <el-dropdown class="ml-3" @command="onExport" v-else>
          <el-button type="text" size="small">导出</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="PDF">导出PDF</el-dropdown-item>
            <el-dropdown-item command="Excel">导出Excel</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <el-tabs class="header-tabs" v-model="condition.tabId" @tab-click="changeTab">
      <el-tab-pane v-for="tb of tabList" :key="tb.key" :label="`${tb.label} ${statisticsNum[tb.skey]}`" :name="`${tb.key}`" />
    </el-tabs>
    <template v-if="list.length > 0">
      <div class="w-full pt-4 box-border flex items-center justify-end text-medium text-theme-black-850 leading-22">
        结算项目
        <span class="text-medium font-semibold">&nbsp;{{ statistics.projectNum }}&nbsp;</span>
        个，结算总费用合计
        <span class="text-medium font-semibold">&nbsp;{{ statistics.operationalYuanAmount | formatPrice }}&nbsp;</span>
        元
      </div>
      <div class="w-full pb-2 box-border flex items-center justify-end text-medium text-theme-black-850 leading-22">
        其中，调查员
        <span class="text-medium font-semibold">&nbsp;{{ statistics.investigatorsNum }}&nbsp;</span>
        人， 到手金额
        <span class="text-medium font-semibold">&nbsp;{{ statistics.investigatorExpectedYuanAmount | formatPrice }}&nbsp;</span>
        元，服务费
        <span class="text-medium font-semibold">&nbsp;{{ statistics.investigatorServiceYuanAmount | formatPrice }}&nbsp;</span>
        元，结算总费用
        <span class="text-medium font-semibold"
          >&nbsp;{{ statistics.investigatorOperationalYuanAmount | formatPrice }}&nbsp;</span
        >
        元，代理
        <span class="text-medium font-semibold">&nbsp;{{ statistics.agentNum }}&nbsp;</span>
        个，结算总费用
        <span class="text-medium font-semibold">&nbsp;{{ statistics.agentOperationalYuanAmount | formatPrice }}&nbsp;</span>
        元
      </div>
    </template>
    <div class="pt-3" v-else />
    <div class="flex-1 overflow-hidden">
      <data-table
        ref="dataTable"
        class="sms_table w-full h-full overflow-hidden"
        cell-class-name="truncate-table-cell-wrap"
        align="left"
        height="calc(100% - 48px - 30px)"
        :data="list"
        :loading="tableLoading"
        :columns="columns"
        :show-page="list.length > 0"
        :page="page"
        :show-tooltip="true"
        @size-change="changeSize"
        @pagination-current-change="changeNum"
        @row-click="toDetail"
      >
        <!-- 表头插槽 -->
        <template v-for="item of columns" :slot="item.headName">
          <div :key="item.value">
            <span>{{ item.label }}</span>
            <el-tooltip :content="item.content" placement="top">
              <span>
                <i class="icon-shuoming text-theme-black-350 ml-0.5 cursor-pointer text-medium"></i>
              </span>
            </el-tooltip>
          </div>
        </template>
        <template #settleNo="{ row }">
          <span>{{ row.settleNo || '—' }}</span>
        </template>
        <template #settleMonth="{ row }">
          <div>
            <span>{{ row.settleMonth || '—' }}</span>
            <i class="ml-2 el-icon-edit text-medium cursor-pointer" @click.stop="openSettleDialog(row)"></i>
          </div>
        </template>
        <template #settleObjType="{ row }">
          <span>{{ soTypeMap[row.settleObjType] || '—' }}</span>
        </template>
        <template #creatorName="{ row }">
          <el-tooltip
            :content="row.creatorPhone"
            effect="light"
          >
            <span>{{ row.creatorName }}</span>
          </el-tooltip>
        </template>
        <template #expectedYuanAmount="{ row }">
          <span v-if="soTypeCode.INVEST === row.settleObjType">
            {{ row.expectedYuanAmount | formatPrice }}
          </span>
          <span v-else>—</span>
        </template>
        <template #serviceYuanAmount="{ row }">
          <span v-if="soTypeCode.INVEST === row.settleObjType">
            {{ row.serviceYuanAmount | formatPrice }}
          </span>
          <span v-else>—</span>
        </template>
        <template #operationalYuanAmount="{ row }">
          <span>{{ row.operationalYuanAmount | formatPrice }}</span>
        </template>
        <template #auditStatus="{ row }">
          <status
            :point-color="getColor(row.auditStatus, row.currentAuditorIsMe, row.currentAuditorName)"
            :text="getStatus(row.auditStatus, row.currentAuditorIsMe, row.currentAuditorName)"
          />
        </template>
        <template #action="{ row }">
          <el-button type="text" @click.stop="toDetail(row)">查看</el-button>
        </template>
        <template #table-footer>
          <!-- 网站协议文案提示 -->
          <DygcFooter class="mt-2 -mb-2" />
        </template>
      </data-table>
    </div>
    <initiate-settle-dialog
      :visible.sync="showSettle"
      :page-type="settlePageType"
      :statement-id="settleInfo.statementId"
      :settle-info="settleSource"
      :disableds="settleDisableds"
      @submit="submitSuccess"
    />
  </div>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import Status from '@/components/base/Status'
import InputFieldRange from '@/components/base/InputFieldRange'
import { filtersMixins } from '@/mixins/relate-settlement'
import { pageMixins } from '@/mixins/publish'
import {
  getSettleStatisticsDetail,
  getSettleStatisticsNum,
  downloadProjectDetailExcel,
  downloadProjectDetailPDF
} from '@/api/cost-settlement/settlement-statistics/projectDetail'
import InitiateSettleDialog from '@/views/home/cost-settlement/components/InitiateSettleDialog'
import SubjectionDateType from '../components/SubjectionDateType'
import { projectDetailColumns, auditStatusMap, auditStatusCode, soTypeCode, soTypeMap, soTypeMapOption } from '../config/cost-sett'
import { tabKey, tabList } from '../config/statis-sett'
import { projectCategoryMap } from '../config/undertake'
import { initiateSettleMixins } from '../mixins'
import DygcFooter from 'components/dygc-footer-bottom/index'

export default {
  name: 'ProjectDetail',
  components: {
    DataTable,
    Status,
    InputFieldRange,
    SubjectionDateType,
    DygcFooter,
    InitiateSettleDialog
  },
  mixins: [pageMixins, filtersMixins, initiateSettleMixins],
  data() {
    return {
      tabList,
      soTypeMap,
      soTypeMapOption,
      projectCategoryMap,
      soTypeCode,
      condition: {
        // statementIds: [],
        dateRange: [],
        settleName: '',
        settleDept: '',
        settleCode: '',
        creatorName: '',
        investigatorName: '',
        investigatorPhone: '',
        projectCategory: null,
        tabId: `${tabKey.ALL}`,
        settleObjType: '',
        settleMonth: '',
        totalAmountRange: []
      },
      columns: projectDetailColumns,
      tableLoading: false,
      list: [],
      statistics: {
        projectNum: 0,
        operationalYuanAmount: 0,
        investigatorsNum: 0,
        investigatorExpectedYuanAmount: 0,
        investigatorServiceYuanAmount: 0,
        investigatorOperationalYuanAmount: 0,
        agentNum: 0,
        agentOperationalYuanAmount: 0
      },
      statisticsNum: {
        all: 0,
        ready: 0,
        paying: 0,
        paid: 0
      },
      tabLoading: false,
      exportLoading: false,
      settleTimeType: 'm'
    }
  },
  mounted() {
    this.setParams()
    this.queryList()
  },
  methods: {
    getStatus(status, isMe, name) {
      const map = auditStatusMap[status]
      if (map) {
        if (typeof map === 'function') {
          return map(isMe, name)[0]
        }
        return map[0]
      }
      return '—'
    },
    getColor(status, isMe, name) {
      const map = auditStatusMap[status]
      if (map) {
        if (typeof map === 'function') {
          return map(isMe, name)[1]
        }
        return map[1]
      }
      return ''
    },
    setParams() {
      const nils = ['', null, undefined]
      const { settleName, settleDept, settleCode, settleObjType, creatorName, investigatorName, investigatorPhone, searchDate, projectCategory } = this.$route.query || {}
      this.condition.settleName = settleName ? decodeURIComponent(settleName) : ''
      this.condition.settleDept = settleDept ? decodeURIComponent(settleDept) : ''
      this.condition.settleCode = settleCode ? decodeURIComponent(settleCode) : ''
      this.condition.settleObjType = !nils.includes(settleObjType) ? `${settleObjType}` : ''
      this.condition.creatorName = creatorName ? decodeURIComponent(creatorName) : ''
      this.condition.investigatorName = investigatorName ? decodeURIComponent(investigatorName) : ''
      this.condition.investigatorPhone = investigatorPhone ? decodeURIComponent(investigatorPhone) : ''
      this.condition.projectCategory = !nils.includes(projectCategory) ? `${projectCategory}` : null
      const searchDateStr = nils.includes(searchDate) ? '' : decodeURIComponent(searchDate)
      this.condition.dateRange = !nils.includes(searchDateStr) ? searchDateStr.split(',') : []
    },
    getSSNum() {
      const req = this.getParams()
      delete req.tabId
      // delete req.descs;
      this.tabLoading = true
      getSettleStatisticsNum(req)
        .then(res => {
          const { code, msg, data } = res?.data || {}
          if (code === 0) {
            const { all, ready, paying, paid } = data || {}
            this.statisticsNum.all = all
            this.statisticsNum.ready = ready
            this.statisticsNum.paying = paying
            this.statisticsNum.paid = paid
          } else {
            this.$message.error(msg ?? '获取统计数量失败')
          }
        })
        .catch(() => {
          this.$message.error('获取统计数量失败')
        })
        .finally(() => {
          this.tabLoading = false
        })
    },
    getParams() {
      const {
        // statementIds,
        dateRange,
        settleName,
        settleDept,
        settleCode,
        creatorName,
        investigatorName,
        investigatorPhone,
        projectCategory,
        tabId,
        settleObjType,
        settleMonth,
        totalAmountRange
      } = this.condition
      const [createTimeStart, createTimeEnd] = dateRange || []
      const [operationalYuanAmountMin, operationalYuanAmountMax] = totalAmountRange || []
      const parmas = {
        tabId
        // descs: 'update_time',
      }
      // if (statementIds.length > 0) {
      //   parmas.statementIds = statementIds
      // }
      if (createTimeStart) {
        parmas.createTimeStart = createTimeStart
      }
      if (createTimeEnd) {
        parmas.createTimeEnd = createTimeEnd
      }
      if (settleName) {
        parmas.settleName = settleName
      }
      if (settleDept) {
        parmas.settleDept = settleDept
      }
      if (settleCode) {
        parmas.settleCode = settleCode
      }
      if (creatorName) {
        parmas.creatorName = creatorName
      }
      if (investigatorName) {
        parmas.investigatorName = investigatorName
      }
      if (investigatorPhone) {
        parmas.investigatorPhone = investigatorPhone
      }
      if (!['', null, undefined].includes(projectCategory)) {
        parmas.projectCategory = +projectCategory
      }
      if (settleObjType) {
        parmas.settleObjType = settleObjType
      }
      if (settleMonth && this.settleTimeType === 'm') {
        parmas.settleMonth = settleMonth
      }
      if (settleMonth && this.settleTimeType === 'q') {
        const settleQuarter = this.$refs.subDate ? this.$refs.subDate.getQuarterFieldValue() : ''
        if (settleQuarter) {
          parmas.settleMonth = settleQuarter
        }
      }
      if (!['', null, undefined].includes(operationalYuanAmountMin)) {
        parmas.operationalYuanAmountMin = operationalYuanAmountMin
      }
      if (!['', null, undefined].includes(operationalYuanAmountMax)) {
        parmas.operationalYuanAmountMax = operationalYuanAmountMax
      }
      return parmas
    },
    getList() {
      const { currentPage, pageSize } = this.page
      const parmas = {
        current: currentPage,
        size: pageSize,
        ...this.getParams()
      }
      this.tableLoading = true
      getSettleStatisticsDetail(parmas)
        .then(res => {
          const {
            records,
            total,
            current,
            size,
            projectNum,
            operationalYuanAmount,
            investigatorsNum,
            investigatorExpectedYuanAmount,
            investigatorServiceYuanAmount,
            investigatorOperationalYuanAmount,
            agentNum,
            agentOperationalYuanAmount
          } = res?.data?.data || {}
          this.list = records || []
          this.page.total = total ?? 0
          this.page.currentPage = current
          this.page.pageSize = size
          this.statistics.projectNum = projectNum ?? 0
          this.statistics.investigatorsNum = investigatorsNum ?? 0
          this.statistics.investigatorExpectedYuanAmount = investigatorExpectedYuanAmount ?? 0
          this.statistics.investigatorServiceYuanAmount = investigatorServiceYuanAmount ?? 0
          this.statistics.investigatorOperationalYuanAmount = investigatorOperationalYuanAmount ?? 0
          this.statistics.agentNum = agentNum ?? 0
          this.statistics.agentOperationalYuanAmount = agentOperationalYuanAmount ?? 0
          this.statistics.operationalYuanAmount = (investigatorOperationalYuanAmount ?? 0) + (agentOperationalYuanAmount ?? 0)
        })
        .catch(() => {
          this.$message.error('获取结算项目明细列表失败')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    queryList() {
      this.getSSNum()
      this.searchList()
    },
    resetList() {
      this.condition.dateRange = []
      this.condition.settleName = ''
      this.condition.settleDept = ''
      this.condition.settleCode = ''
      this.condition.creatorName = ''
      this.condition.investigatorName = ''
      this.condition.investigatorPhone = ''
      this.condition.projectCategory = ''
      this.condition.tabId = `${tabKey.ALL}`
      this.condition.settleObjType = ''
      this.condition.settleMonth = ''
      this.condition.totalAmountRange = []
      // this.condition.statementIds = []
      this.settleTimeType = 'm'
      if (this.$refs.subDate) {
        this.$refs.subDate.reset()
      }
      this.queryList()
    },
    changeTab() {
      this.searchList()
    },
    toDetail(item) {
      const isPay = [auditStatusCode.WAITPAY, auditStatusCode.ALREADYPAY].includes(+item.auditStatus)
      const urlStr = isPay ? 'relate-pay' : 'relate-approval'
      const typePage = isPay ? 'readonlyPay' : 'approval'
      const url = `${window.location.origin}${process.env.VUE_APP_PRE_URL}#/relate-detail/${urlStr}/${item.id}?settleObjType=${
        item.settleObjType ?? ''
      }&typePage=${typePage}&from=projectDetail`
      window.open(url)
    },
    exportPDF() {
      const req = this.getParams()
      this.exportLoading = true
      downloadProjectDetailPDF(req)
        .then(res => {
          window.open(res?.data?.data)
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    exportExcel() {
      const req = this.getParams()
      this.exportLoading = true
      downloadProjectDetailExcel(req)
        .then(res => {
          const url = res?.data?.data
          window.open(url)
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    onExport(type) {
      if (!this.exportLoading) {
        if (type === 'PDF') {
          this.exportPDF()
        } else if (type === 'Excel') {
          this.exportExcel()
        }
      }
    },
    blurAmountHandle() {
      const [st, ed] = this.condition.totalAmountRange || []
      const start = parseFloat(st)
      const end = parseFloat(ed)
      this.condition.totalAmountRange.splice(0, 1, Number.isNaN(start) ? '' : +start.toFixed(2))
      this.condition.totalAmountRange.splice(1, 1, Number.isNaN(end) ? '' : +end.toFixed(2))
    },
    submitSuccess() {
      this.getList();
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-range-editor--small .el-range-separator {
  width: auto;
}
</style>